export default {
  "content": "<path d=\"M6.012 15.004a.5.5 0 100 1zm5.982 1a.5.5 0 100-1zm-3.527-3.128v2.5h1v-2.5zM15.327.004H2.602v1h12.727zm-12.726 0C1.698.004.964.737.964 1.64h1c0-.35.286-.636.637-.636zM.964 11.672c0 .903.734 1.636 1.637 1.636v-1a.637.637 0 01-.637-.636zm14.364 1.636c.902 0 1.636-.733 1.636-1.636h-1c0 .35-.285.636-.636.636zM16.964 1.64c0-.903-.733-1.636-1.636-1.636v1c.35 0 .636.286.636.636zm-16 0v8.235h1V1.64zm16 8.235V1.64h-1v8.235zm-15.5.5h15v-1h-15zm-.5-.5v1.797h1V9.875zm1.637 3.433h12.727v-1H2.6zm14.363-1.636V9.875h-1v1.797zM6.012 16.004h5.982v-1H6.012z\" fill=\"#636360\"/>",
  "attrs": {
    "fill": "none",
    "height": "17",
    "viewBox": "0 0 17 17",
    "width": "17",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};